import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { NavigationService } from '../navigation/navigation.service';
import { LoginComponent } from './login/login.component';
import { ProfileModule } from './profile/profile.module';

@NgModule({
    declarations: [LoginComponent],
    imports: [CommonModule, MaterialModule, ProfileModule],
    exports: [LoginComponent],
    providers: [NavigationService]
})
export class AuthenticationModule {}
